import React, { memo } from 'react';

const SendInner = () => (
    <svg viewBox="0 0 24 24" data-testid="send">
        <path d="M4.7687 4.70741L3 4L3.42221 5.85754L4.8181 11.9989L3.42221 18.1402L3 19.9977L4.7687 19.2903L20.6776 12.9273L22.9991 11.9989L20.6776 11.0704L4.7687 4.70741ZM6.58361 10.7428L5.79467 7.2718L17.6135 11.9989L5.79467 16.7259L6.58445 13.2512L10.6888 11.9972L6.58361 10.7428Z" />
    </svg>
);

export const Send = memo(SendInner);
